<template>
  <div class="gc-page-project-wrap">
    <van-nav-bar :border="false"
                 title="项目交付审核"
                 left-arrow
                 @click-left="$router.back()"
    />
    <div class="page-project-wrap box">
      <div class="item">
        <span>项目名称：</span>{{ detailInfo.Item.Name }}
      </div>
      <div class="item">
        <span>项目编号：</span>{{ detailInfo.Item.Sysno }}
      </div>
      <div class="item">
        <span>项目金额：</span>¥{{ detailInfo.ProALLMoney }}
      </div>
      <div class="item">
        <span>项目时间：</span>{{ detailInfo.PlanStartDate.substr(0, 10) }}至{{ detailInfo.PlanOverTime.substr(0, 10) }}
      </div>
      <div class="item">
        <span>项目标签：</span>{{ detailInfo.ProSource ? '外部' : '内部' }}
      </div>
      <div class="item" style="display:block">
        <span>项目描述</span>
        <div class="tip">
          {{ detailInfo.ProRemark }}
        </div>
      </div>
    </div>

    <div v-if="detailInfo.AcItemLst && detailInfo.AcItemLst[0].UserWorkNo" class="page-member-wrap box">
      <div class="title">
        <span class="s1">出资人员</span>
        <span class="s2">权重</span>
        <span class="s2">金额</span>
      </div>
      <div class="info-wrap">
        <div class="info-item" v-for="(item,index) in detailInfo.AcItemLst" :key="index">
          <span class="s1">{{ item.UserDepName }}-{{ item.Item.Name }}</span>
          <span class="s2">{{ item.WorkRight }}%</span>
          <span class="s2">{{ item.WorkWeight }}</span>
        </div>
      </div>
    </div>
    <div v-if="detailInfo.AcItemLst && !detailInfo.AcItemLst[0].UserWorkNo" class="page-dep-wrap box">
      <div class="item">
        <span>出资人员：</span>
        <div class="info">
          {{ detailInfo.AcItemLst[0].UserDepName }}
        </div>
      </div>
    </div>

    <div class="page-dep-wrap box">
      <div class="item">
        <span>验收人员：</span>
        <div class="info">
          <p>{{ detailInfo.AcceptanceName }}</p>
        </div>
      </div>
      <div class="item">
        <span>参与部门：</span>
        <div class="info">
          <p v-for="(item2,index) in detailInfo.DepType" :key="index">{{ item2 }}</p>
        </div>
      </div>
      <!-- <div class="item">
          <span>出资人员：</span>
          <div class="info">
              <p>技术中心-总监-陈军</p>
              <p>技术中心-总监-陈军</p>
              <p>技术中心-总监-陈军</p>
          </div>
      </div>   -->
    </div>
    <div v-if="detailInfo.ItemLst" class="page-member-wrap box">
      <div class="title">
        <span class="s1">已参与人员</span>
        <span class="s2">权重</span>
        <span class="s2">进度</span>
      </div>
      <div class="info-wrap">
        <div class="info-item" v-for="(item,index) in detailInfo.ItemLst" :key="index">
          <span class="s1">{{ item.UserDepName }}-{{ item.Item.Name }}</span>
          <span class="s2">{{ item.WorkWeight }}%</span>
          <span class="s2">{{ item.ProStatus }}%</span>
        </div>
      </div>
    </div>
    <!-- <div v-if="detailInfo.ItemLst" class="page-member-wrap box">
        <div class="title">
            <span class="s1">已参与人员</span>
            <span class="s2">权重</span>
            <span class="s2">进度</span>
        </div>
        <div class="info-wrap">
            <div  class="info-item" v-for="(item,index) in detailInfo.ItemLst" :key="index">
                <span class="s1">{{item.UserDepName}}-{{item.Item.Name}}</span>
                <span class="s2">
                    <div class="input-wrap">
                        <div class="input" @click="showWeightPicker(index)">{{item.WorkWeight?item.WorkWeight:'请选择'}}<i>%</i></div>
                    </div>
                </span>
                <span class="s2">{{item.ProStatus}}%</span>
            </div>
        </div>
    </div> -->

    <div class="project-end-wrap">
      <!-- <div class="item" @click="showEndTime=true">
          <span>实际交付时间：</span>
          <div class="info">{{endDate}}</div>
      </div> -->
      <div class="item">
        <span>实际交付时间：</span>
        <div class="info">{{ detailInfo.OverTime }}</div>
      </div>
      <div class="item">
        <span>实际出资金额：</span>
        ￥{{ detailInfo.ProALLMoney }}
        <!-- <input type="number" v-model="payMoney" class="money"> -->
      </div>
    </div>
    <div class="submit-btn dis" v-if="isEnd">已结束</div>
    <div class="submit-btn" v-else @click="handleDeliver">确 定</div>

    <!-- 选择时间 -->
    <van-popup v-model="showEndTime" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="实际交付时间"
        @confirm="onConfirmEndTime"
        @cancel="showEndTime=false"
      />
    </van-popup>

    <!-- 选择权重 -->
    <van-popup v-model="showWeight" position="bottom">
      <van-picker
        ref="weight"
        show-toolbar
        :columns="columnsWeight"
        @confirm="onConfirmWeight"
        @cancel="showWeight=false"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      detailInfo: {
        Item: {
          Name: ''
        },
      },
      showEndTime: false,
      endDate: '请选择',
      currentDate: new Date(),
      payMoney: '',
      isEnd: false,

      // 权重
      showWeight: false,
      weightActiveIndex: 0,
      columnsWeight: [],
    }
  },
  mounted() {
    this.WebGetDealProjectInfoEx();
    for (let i = 1; i <= 100; i++) {
      this.columnsWeight.push(i)
    }
  },
  methods: {
    // 项目详情
    WebGetDealProjectInfoEx() {
      let data = {
        DepSysno: this.$route.params.sysno,
        UserId: localStorage.getItem('UserSysno')
      }
      this.$baseajax.normalJsonp(this.$base.baseProject + '/WebGetDealProjectInfoEx', data, res => {
        console.log(res);
        res = res.WebGetDealProjectInfoExResult
        if (res.ResponseCode == 1) {
          this.detailInfo = res.Item;
        }
      }, err => {
      })
    },
    // 交付确认
    WebUpdatePayProMsg() {
      let data = {
        Item: {
          ProSysno: this.$route.params.sysno,
          // PayMoney: this.payMoney,//交付金额
          PayMoney: this.detailInfo.ProALLMoney
        }
      }
      this.$baseajax.normalJsonp(this.$base.baseEvent + '/WebUpdatePayProMsg', data, res => {
        console.log(res);
        res = res.WebUpdatePayProMsgResult;
        if (res.ResponseCode == 1) {
          this.$toast('已确认交付')
          // this.$router.back();
          this.isEnd = true
        } else {
          this.$toast(res.ResponseMessage)
        }

      }, err => {
      })
    },
    handleDeliver() {
      // let percent = 0
      // for(let obj of this.detailInfo.ItemLst){
      //     percent += Number(obj.WorkWeight)
      // }
      // if(percent!=100){
      //     this.$toast('参与权重和一定要等于100')
      //     return
      // }
      if (!this.detailInfo.ProALLMoney || this.detailInfo.ProALLMoney == 0) {
        this.$toast('网络异常请稍后重试')
        return
      }
      // if(!this.payMoney||this.payMoney==0){
      //     this.$toast('请输入回款金额')
      //     return
      // }
      this.WebUpdatePayProMsg();
    },
    onConfirmEndTime(e) {
      let year = e.getFullYear();
      let month = e.getMonth() + 1;
      month = month < 10 ? '0' + month : month;
      let day = e.getDate();
      day = day < 10 ? '0' + day : day;
      this.endDate = year + '-' + month + '-' + day;
      console.log(this.endDate);
      this.showEndTime = false
    },

    //选择权重
    showWeightPicker(index) {
      this.weightActiveIndex = index
      this.showWeight = true
      let v = this.detailInfo.ItemLst[this.weightActiveIndex].WorkWeight ? this.detailInfo.ItemLst[this.weightActiveIndex].WorkWeight : 1
      this.$nextTick(() => {
        this.$refs.weight.setValues([v]);
      })

    },
    onConfirmWeight(v) {
      this.detailInfo.ItemLst[this.weightActiveIndex].WorkWeight = v
      this.showWeight = false
    },

  },
}
</script>
<style lang="less" scoped>
.project-end-wrap {
  margin: .28rem .28rem 0;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  line-height: 2;
  background-color: #ffffff;
  box-shadow: 0rem 0rem 0.28rem 0rem rgba(211, 47, 47, 0.14);
  border-radius: 0.27rem;

  .item {
    display: flex;
    align-items: center;
    padding: .4rem 0;
    border-top: 1PX solid #eee;
    font-size: 0.37rem;
    color: #666666;

    &:first-child {
      border-top: none;
    }

    span {
      width: 3rem;
      flex: 0 0 3rem;
      color: #333333;
    }

    .money {
      padding: .15rem .2rem;
      margin-left: 0.1rem;
      line-height: 1;
      width: 2.6rem;
      // min-width: 2rem;
      font-size: 0.37rem;
      color: #666666;
      background-color: #f0f0f0;
      border-radius: 0.13rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/project/ReviewEnd.vue